import { algoliasearch } from "algoliasearch";

// Configuración de Algolia
export const ALGOLIA_CONFIG = {
  appId: import.meta.env.VITE_ALGOLIA_APPLICATION_ID || "TU_APP_ID",
  searchApiKey:
    import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY || "TU_SEARCH_API_KEY",
  indexName: import.meta.env.VITE_ALGOLIA_INDEX_NAME || "products",
};

// Cliente de búsqueda para react-instantsearch
export const searchClient = algoliasearch(
  ALGOLIA_CONFIG.appId,
  ALGOLIA_CONFIG.searchApiKey
);

// Tipos para los resultados de búsqueda
export interface AlgoliaProduct {
  objectID: string;
  name: string;
  description?: string;
  price?: number;
  image?: string;
  category?: string;
  brand?: string;
  sku?: string;
  inStock?: boolean;
  rating?: number;
  reviewCount?: number;
}

// Configuración de búsqueda
export const SEARCH_CONFIG = {
  hitsPerPage: 8,
  attributesToRetrieve: [
    "objectID",
    "name",
    "description",
    "price",
    "image",
    "category",
    "brand",
    "sku",
    "inStock",
    "rating",
    "reviewCount",
  ],
  attributesToHighlight: ["name", "description"],
  attributesToSnippet: ["description:50"],
};
